import { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * Typography configuration for Yugen Frontend
 * - Base font: Montserrat (sans-serif)
 * - Headings: Playfair Display (serif) for elegance
 */
export const typography: TypographyOptions = {
  fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',

  // Headings use Playfair Display serif font
  h1: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    fontWeight: 700,
    fontSize: '3.5rem',
    lineHeight: 1.2,
    letterSpacing: '-0.01562em',
  },

  h2: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    fontWeight: 700,
    fontSize: '2.75rem',
    lineHeight: 1.3,
    letterSpacing: '-0.00833em',
  },

  h3: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    fontWeight: 600,
    fontSize: '2.25rem',
    lineHeight: 1.4,
    letterSpacing: '0em',
  },

  h4: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    fontWeight: 600,
    fontSize: '1.75rem',
    lineHeight: 1.4,
    letterSpacing: '0.00735em',
  },

  h5: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.5,
    letterSpacing: '0em',
  },

  h6: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
  },

  // Body text
  body1: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.7,
    letterSpacing: '0.00938em',
  },

  body2: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.6,
    letterSpacing: '0.01071em',
  },

  // Button text
  button: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.75,
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
  },

  // Caption and overline
  caption: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.03333em',
  },

  overline: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase',
  },

  // Subtitle variants
  subtitle1: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.75,
    letterSpacing: '0.00938em',
  },

  subtitle2: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '0.00714em',
  },
};
